import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CalculatorResult } from '../../../../models/analysis/solar-calculator-result';
import { inOutAnimation } from '../../../../animations';
import { CalculatorResultWrapper } from '../../../../models/analysis/calculator-result-wrapper';
import { PowerPlant } from '../../model/power-plant';

@Component({
  selector: 'psc-hourly-tool-result',
  templateUrl: './hourly-tool-result.component.html',
  animations: [inOutAnimation({})],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HourlyToolResultComponent {

  @Input() calculatorResultWrapper: CalculatorResultWrapper;
  @Input() powerPlant: PowerPlant;

  get hourlySolarCalculatorResult(): CalculatorResult {
    return this.calculatorResultWrapper.result;
  }
}
